const ru = {
  "app.tagline": "Премиальный маркетплейс онлайн-игр",
  "nav.marketplace": "Маркетплейс",
  "nav.orders": "Заказы",
  "nav.dashboard": "Панель",
  "nav.chat": "Сообщения",
  "nav.login": "Войти",
  "nav.register": "Регистрация",
  "nav.logout": "Выйти",
  "nav.account": "Аккаунт",
  "landing.hero.title": "Надёжная торговля в онлайн-играх",
  "landing.hero.sub": "Валюта, аккаунты, предметы и услуги бустинга от MQL Group. Безопасные сделки, быстрая доставка.",
  "landing.cta.browse": "Смотреть товары",
  "landing.cta.register": "Зарегистрироваться",
  "landing.f1.title": "Безопасные сделки",
  "landing.f1.desc": "Платежи проверяет команда MQL Group",
  "landing.f2.title": "Быстрая доставка",
  "landing.f2.desc": "Средняя доставка менее 30 минут",
  "landing.f3.title": "Проверенные поставщики",
  "landing.f3.desc": "Товар только от поставщиков, прошедших KYC",
  "landing.f4.title": "Премиальный сервис",
  "landing.f4.desc": "Поддержка в чате 24/7 от опытных сотрудников",
  "auth.email": "Email",
  "auth.password": "Пароль",
  "auth.name": "Имя",
  "auth.role": "Зарегистрироваться как",
  "auth.role.buyer": "Покупатель",
  "auth.role.supplier": "Поставщик",
  "auth.login": "Войти",
  "auth.register": "Регистрация",
  "auth.have_account": "Уже есть аккаунт?",
  "auth.no_account": "Нет аккаунта?",
  "auth.forgot": "Забыли пароль?",
  "auth.welcome_back": "С возвращением",
  "auth.welcome": "Добро пожаловать",
  "auth.login_failed": "Не удалось войти",
  "auth.register_failed": "Ошибка регистрации",
  "auth.accept_prefix": "Я прочитал(а) и принимаю",
  "auth.policy.buyer": "Правила для покупателей",
  "auth.policy.supplier": "Правила для поставщиков",
  "kyc.notice": "Поставщики обязаны пройти KYC. Аккаунт станет доступен после одобрения удостоверения личности администратором. Фото видят только Владелец и Персонал.",
  "kyc.telegram": "Имя пользователя Telegram",
  "kyc.whatsapp": "Номер WhatsApp",
  "kyc.contact_hint": "Укажите хотя бы одно: Telegram или WhatsApp, чтобы администратор мог связаться с вами.",
  "kyc.ktp": "Фото удостоверения личности (KTP)",
  "kyc.ktp_hint": "Документ виден полностью и чётко.",
  "kyc.selfie": "Селфи с удостоверением",
  "kyc.selfie_hint": "Лицо и документ чётко видны на одном фото.",
  "kyc.sent_title": "Заявка отправлена",
  "kyc.sent_body": "Администратор проверяет ваши данные KYC. После одобрения вы получите email и сможете войти.",
  "market.search": "Поиск товаров...",
  "market.all_games": "Все игры",
  "market.all_categories": "Все категории",
  "market.in_stock": "Только в наличии",
  "market.buy": "Купить",
  "market.detail": "Подробнее",
  "market.stock": "В наличии",
  "market.all_servers": "Все серверы",
  "market.all_regions": "Все регионы",
  "market.all_factions": "Все фракции",
  "market.min_price": "Цена от (IDR)",
  "market.max_price": "Цена до (IDR)",
  "market.apply": "Применить",
  "market.reset": "Сбросить",
  "market.err_minmax": "Минимальная цена больше максимальной",
  "market.load_failed": "Не удалось загрузить товары",
  "product.description": "Описание",
  "product.add_to_order": "Заказать",
  "product.quantity": "Количество",
  "product.stock_after": "Остаток после покупки",
  "product.qty_decrease": "Уменьшить количество",
  "product.qty_increase": "Увеличить количество",
  "product.qty_max": "Макс",
  "product.not_found": "Товар не найден",
  "product.not_found_sub": "Этот товар больше недоступен или удалён.",
  "product.back": "Вернуться в маркетплейс",
  "product.login_first": "Сначала войдите в аккаунт",
  "product.buyers_only": "Заказывать могут только покупатели",
  "product.invalid_qty": "Неверное количество",
  "product.order_created": "Заказ создан",
  "product.order_failed": "Не удалось создать заказ",
  "checkout.title": "Информация о заказе",
  "checkout.sub": "Выберите способ доставки и проверьте сводку перед подтверждением.",
  "checkout.payment_method": "Способ оплаты",
  "checkout.notes": "Примечание к доставке",
  "checkout.total": "Итого",
  "checkout.method": "Способ доставки",
  "checkout.character": "Имя персонажа",
  "checkout.account_id": "ID аккаунта / User ID",
  "checkout.auction_notes": "Детали лота (предмет, цена, время)",
  "checkout.product": "Товар",
  "checkout.game_server": "Игра / Сервер",
  "checkout.qty": "Количество",
  "checkout.unit_price": "Цена за единицу",
  "checkout.fee": "Доп. сбор",
  "checkout.payment": "Оплата",
  "checkout.grand_total": "Сумма заказа",
  "checkout.use_balance": "Использовать баланс магазина",
  "checkout.balance_available": "Доступно",
  "checkout.balance_used": "Оплачено балансом магазина",
  "checkout.amount_due": "К оплате",
  "checkout.usd_note": "Этот способ оплачивается в USD по курсу, зафиксированному при создании заказа.",
  "checkout.confirm": "Подтвердить заказ",
  "checkout.processing": "Обработка...",
  "delivery.mail": "Почта",
  "delivery.mail.desc": "Предметы отправляются внутриигровой почтой вашему персонажу.",
  "delivery.trade": "Обмен / Прямая передача",
  "delivery.trade.desc": "Сотрудник MQL встречает вашего персонажа в игре и проводит обмен.",
  "delivery.auction": "Аукцион",
  "delivery.auction.desc": "Вы выставляете дешёвый предмет на аукцион, сотрудник MQL выкупает его на сумму заказа.",
  "delivery.topup": "Прямое пополнение",
  "delivery.topup.desc": "Баланс зачисляется прямо на ваш игровой аккаунт/ID.",
  "delivery.service": "Услуга от команды MQL",
  "delivery.service.desc": "Бустинг/прокачку/квесты выполняет команда MQL. Данные для входа и график согласуются через Сообщения после проверки оплаты. Не пишите пароли в примечаниях.",
  "delivery.account_handover": "Передача аккаунта",
  "delivery.account_handover.desc": "Данные для входа в аккаунт сотрудник отправит через Сообщения после проверки оплаты.",
  "order.status.waiting_payment": "Ожидает оплаты",
  "order.status.verifying": "Проверка оплаты",
  "order.status.preparing": "Подготовка",
  "order.status.shipped": "Отправлено",
  "order.status.completed": "Завершён",
  "order.status.cancelled": "Отменён",
  "order.status.resolution": "Спор",
  "order.status.trade_ready": "Сотрудник готов к обмену",
  "order.status.partial_delivery": "Частичная доставка",
  "order.upload_proof": "Загрузить подтверждение оплаты",
  "order.my_orders": "Мои заказы",
  "order.all": "Все",
  "order.no": "№ заказа",
  "order.date": "Дата",
  "order.items": "Товары",
  "order.status": "Статус",
  "order.detail": "Подробнее",
  "order.back": "← Назад",
  "order.payment_proof": "Подтверждение оплаты",
  "order.history": "История статусов",
  "order.payment": "Оплата",
  "order.delivery": "Доставка",
  "order.character": "Персонаж / ID",
  "order.send": "Отправить",
  "order.proof_sent": "Подтверждение оплаты отправлено",
  "order.upload_failed": "Ошибка загрузки",
  "order.max_5mb": "Макс. 5 МБ",
  "order.trade_ready_badge": "Готов к обмену",
  "order.trade_ready_title": "Сотрудник готов к обмену прямо сейчас",
  "order.trade_ready_char": "Пожалуйста, зайдите в игру персонажем",
  "order.shipped_title": "Товары доставлены",
  "order.progress": "Ход доставки",
  "order.delivered": "доставлено",
  "order.refund": "Возврат на баланс магазина",
  "order.balance_used": "Оплачено балансом магазина",
  "order.amount_due": "К оплате",
  "order.unique_code": "Уникальный код",
  "order.pay_within": "Оплатите до истечения времени, иначе заказ будет отменён автоматически",
  "order.pay_expired": "Время оплаты истекло — заказ отменяется",
  "product.min_order": "Минимальная покупка",
  "product.min_order_err": "Минимальная покупка для этого товара — {amount}",
  "order.transfer_exact": "Переведите ТОЧНУЮ сумму выше (включая уникальный код +{code}), чтобы платёж быстро определили.",
  "order.scan_qris": "Отсканируйте в любом банковском приложении / кошельке — сумма заполнится автоматически.",
  "order.scan_usdt": "Отсканируйте криптокошельком, чтобы скопировать адрес.",
  "order.usdt_warning": "Отправляйте USDT только в сети TRON (TRC20). Другие сети — потеря средств.",
  "order.usdt_network_warning": "Отправляйте USDT только в сети {network}. Переводы в других сетях могут быть потеряны.",
  "order.usdt_locked": "Зафиксированный курс: 1 USDT = {rate} · Итого {total}",
  "order.binance_scan": "Отсканируйте в приложении Binance (Pay) или отправьте на UID ниже",
  "order.binance_name": "Имя аккаунта",
  "order.binance_exact": "Оплатите точную сумму USDT выше, затем загрузите подтверждение оплаты.",
  "checkout.usdt_note": "Автоконвертация по актуальному курсу, округление вверх до 2 знаков. Курс фиксируется при создании заказа. 1 USDT = {rate}",
  "checkout.fx_changed": "Курс только что обновился. Проверьте новую сумму USDT и подтвердите снова.",
  "order.rate": "Курс",
  "notif.title": "Уведомления",
  "notif.empty": "Уведомлений пока нет",
  "balance.title": "Баланс магазина",
  "balance.desc": "Возвраты за недоставленную часть отменённых заказов. Можно использовать для следующих покупок в MQL; вывести нельзя.",
  "balance.history": "История баланса",
  "balance.refund": "Возврат",
  "balance.payment": "Оплата",
  "footer.contact": "MQL Store — Контактная информация",
  "footer.phone": "Телефон",
  "policy.buyer": "Правила для покупателей",
  "policy.supplier": "Правила для поставщиков",
  "policy.updated": "Версия",
  "policy.lang_note": "Правила для поставщиков доступны на английском и индонезийском языках.",
  "common.loading": "Загрузка...",
  "common.empty": "Пока нет данных",
  "common.save": "Сохранить",
  "acct.label": "АККАУНТ",
  "acct.title": "Настройки аккаунта",
  "acct.profile": "Профиль",
  "acct.role": "Роль",
  "role.owner": "Владелец",
  "role.staff": "Сотрудник",
  "role.supplier": "Поставщик",
  "role.buyer": "Покупатель",
  "acct.change_pw": "Сменить пароль",
  "acct.current_pw": "Текущий пароль",
  "acct.new_pw": "Новый пароль (мин. 8 символов)",
  "acct.confirm_pw": "Повторите новый пароль",
  "acct.save_pw": "Сохранить новый пароль",
  "acct.saving": "Сохранение...",
  "acct.pw_mismatch": "Пароли не совпадают",
  "acct.pw_changed": "Пароль изменён. Сеансы на других устройствах завершены.",
  "twofa.codes_copied": "Коды восстановления скопированы",
  "twofa.codes_note": "Сохраните коды восстановления в надёжном месте. Каждый код можно использовать один раз, если вы потеряете телефон. Больше они показаны не будут.",
  "twofa.copy": "Копировать",
  "twofa.saved": "Я сохранил(а) их",
  "twofa.enable_start": "Включить Google Authenticator",
  "twofa.step1": "1. Отсканируйте QR-код в приложении Google Authenticator.",
  "twofa.manual": "Не получается отсканировать? Введите ключ вручную:",
  "twofa.step2": "2. Введите 6-значный код из приложения.",
  "twofa.verify": "Проверить и включить",
  "twofa.code_label": "Код Authenticator",
  "twofa.regen": "Создать новые коды восстановления",
  "twofa.mandatory_note": "2FA обязательна для аккаунтов Владельца/Сотрудников и не может быть отключена. Если сотрудник потерял телефон, Владелец может сбросить 2FA в разделе Управление → Аккаунты сотрудников.",
  "twofa.disable": "Отключить 2FA",
  "twofa.disabled": "2FA отключена",
  "twofa.on": "2FA включена — для входа нужен код Authenticator.",
  "twofa.required": "Для вашего аккаунта 2FA обязательна. Включите её, чтобы открыть меню.",
  "twofa.off": "2FA не включена.",
  "twofa.enabled": "2FA включена",
  "sound.title": "Звуки уведомлений",
  "sound.order": "Звук заказа",
  "sound.message": "Звук сообщения",
  "sound.volume": "Громкость",
  "sound.off": "Выкл.",
  "sound.chime": "Перезвон",
  "sound.bell": "Колокольчик",
  "sound.coin": "Монета",
  "sound.ping": "Пинг",
  "sound.test": "Тест",
  "sound.saved": "Настройки звука сохранены",
  "sound.custom_group": "Звуки магазина",
  "sound.autoplay_note": "Звуки воспроизводятся, пока сайт открыт и после того, как вы кликнули на странице (правило браузера).",
  "order.watch_video": "Смотреть видео доставки",
  "order.chat_staff": "Чат с сотрудником",
  "maint.title": "Технические работы",
  "maint.countdown": "Плановые технические работы начнутся через",
  "maint.sub": "Мы обновляем MQL Group. Ваш аккаунт, заказы и баланс магазина в безопасности.",
  "order.refund_title": "{amount} возвращено на ваш баланс магазина",
  "order.refund_body": "Ваши деньги в безопасности. Это возврат за недоставленную часть заказа, его можно сразу использовать для следующей покупки.",
  "order.chat_failed": "Не удалось открыть чат",
};

export default ru;
